/**
 * Atualiza a posição absoluta de um elemento em referência ao "target".
 *
 * @param {HTMLElement} referência
 * @param {HTMLElement} target
 * @param {string} posição
 */
export function atualizarPosição(referência, target, posição) {
    let refRect = referência.getBoundingClientRect()
    let targetRect = target.getBoundingClientRect()

    if (!posição) {
        let ww = window.innerWidth
        let wh = window.innerHeight

        if (refRect.top < wh / 2 && refRect.left < ww / 2) {
            posição = 'bottom-right'
        } else if (refRect.top < wh / 2 && refRect.left >= ww / 2) {
            posição = 'bottom-left'
        } else if (refRect.top >= wh / 2 && refRect.left < ww / 2) {
            posição = 'top-right'
        } else if (refRect.top >= wh / 2 && refRect.left >= ww / 2) {
            posição = 'top-left'
        }
    }

    if (posição == 'left|right') {
        let ww = window.innerWidth
        if (refRect.left < ww / 2) {
            posição = 'right'
        } else {
            posição = 'left'
        }
    }

    if (posição == 'right') {
        target.style.top = refRect.top + refRect.height / 2 - targetRect.height / 2 + 'px'
        target.style.left = refRect.left + refRect.width + 'px'
    } else if (posição == 'left') {
        target.style.top = refRect.top + refRect.height / 2 - targetRect.height / 2 + 'px'
        target.style.left = refRect.left - targetRect.width + 'px'
    } else if (posição == 'bottom-left') {
        target.style.top = refRect.top + refRect.height + 'px'
        target.style.left = refRect.left + refRect.width - targetRect.width + 'px'
    } else if (posição == 'bottom-right') {
        target.style.top = refRect.top + refRect.height + 'px'
        target.style.left = refRect.left + 'px'
    } else if (posição == 'right-bottom') {
        target.style.top = refRect.top + 'px'
        target.style.left = refRect.left + refRect.width + 'px'
    } else if (posição == 'top-right') {
        target.style.top = refRect.top + refRect.height - targetRect.height + 'px'
        target.style.left = refRect.left + refRect.width + 'px'
    } else if (posição == 'top-left') {
        target.style.top = refRect.top - targetRect.height + 'px'
        target.style.left = refRect.left + refRect.width - targetRect.width + 'px'
    }
}
